import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAb7nDstjrigbKP3zCPOqHKnvaiE1WIlig",
  authDomain: "shag00n00.firebaseapp.com",
  projectId: "shag00n00",
  storageBucket: "shag00n00.appspot.com",
  messagingSenderId: "72102585588",
  appId: "1:72102585588:web:65fa8d40c85820a7746aa1",
  measurementId: "G-8K849PZ84B"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);